import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export type BulkSyncTagFromCrmRequest = {
  /** GHL location tag id */
  tagId: string;
  /** Exact CRM tag name used to search contacts */
  tagName: string;
  studioId?: string;
  dryRun?: boolean;
};

export type BulkSyncTagFromCrmCounts = {
  already_tagged: number;
  would_tag: number;
  no_parent: number;
  ambiguous_parents: number;
  skipped_no_email: number;
  tagged: number;
};

export type BulkSyncTagFromCrmResponse = {
  success: boolean;
  dryRun: boolean;
  tagId: string;
  tagName: string;
  ghlContactsWithTag: number;
  counts: BulkSyncTagFromCrmCounts;
  tagged: number;
  failed: number;
  errors: Array<{ parentId?: string; ghlContactId: string; error: string }>;
};

export const bulkSyncTagFromCrmAPI = async (
  params: BulkSyncTagFromCrmRequest,
): Promise<BulkSyncTagFromCrmResponse> => {
  const response = await baseAPI.post<BulkSyncTagFromCrmResponse>(
    '/parents/bulk-sync-tag-from-crm',
    params,
  );
  return response.data;
};

export const useBulkSyncTagFromCrmMutation = () => {
  return useMutation({
    mutationFn: bulkSyncTagFromCrmAPI,
    onSuccess: (data) => {
      if (data.dryRun) return;
      void queryClient.invalidateQueries({ queryKey: [KEYS.PARENT_TAGS] });
      void queryClient.invalidateQueries({ queryKey: [KEYS.PARENTS] });
      void queryClient.invalidateQueries({ queryKey: [KEYS.TAGS] });
    },
  });
};
